<template>
  <div ref="contentElement" class="markdown-math overflow-x-auto text-sm leading-relaxed text-gray-700"></div>
</template>

<script setup>
import DOMPurify from "dompurify";
import "katex/dist/katex.min.css";
import renderMathInElement from "katex/contrib/auto-render";
import { marked } from "marked";
import { nextTick, onMounted, ref, watch } from "vue";
import { preserveMathDelimiters, restoreMathDelimiters } from "./markdownMathDelimiters.mjs";

const props = defineProps({
  content: { type: String, default: "" },
});

const contentElement = ref(null);

async function renderContent() {
  await nextTick();
  if (!contentElement.value) return;

  contentElement.value.innerHTML = DOMPurify.sanitize(
    restoreMathDelimiters(marked.parse(
      preserveMathDelimiters(props.content),
      { gfm: true, breaks: true }
    ))
  );
  renderMathInElement(contentElement.value, {
    delimiters: [
      { left: "$$", right: "$$", display: true },
      { left: "\\[", right: "\\]", display: true },
      { left: "\\(", right: "\\)", display: false },
    ],
    throwOnError: false,
    trust: false,
  });
}

watch(() => props.content, renderContent);
onMounted(renderContent);
</script>

<style scoped>
.markdown-math :deep(table) {
  width: 100%;
  border-collapse: collapse;
}

.markdown-math :deep(th),
.markdown-math :deep(td) {
  border: 1px solid #d1d5db;
  padding: 0.4rem 0.55rem;
  text-align: left;
  vertical-align: top;
}

.markdown-math :deep(th) {
  background: #f9fafb;
  font-weight: 700;
}

.markdown-math :deep(p + p) {
  margin-top: 0.65rem;
}

.markdown-math :deep(.katex-display) {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0.25rem 0;
}
</style>
